import { isEmpty } from 'lodash'

export const getters = {
  account: state => state.account,
  accounts: state => state.accounts,
  isRegulator: (state, getters, rootState) => {
    const account = getters.account
    const hasData = !isEmpty(account)

    if (!hasData) {
      return false
    }

    const isRegulator = !isEmpty(account.expertID)
    return isRegulator
  },
  isAdministrator: (state, getters) => {
    const account = getters.account
    const hasData = !isEmpty(account)

    if (!hasData) return false

    const isAdmin = account.grupoID === 'd7a2100f-d870-405a-a6d0-b0c262176d62'
    return isAdmin
  }
}

export default getters



// WEBPACK FOOTER //
// ./src/store/module/account/getters.js